import { useEffect, useState } from 'react';
import {
  generatePath,
  useMatch,
  useNavigate,
  useParams,
} from 'react-router-dom';
import {
  SidePanel,
  SidePanelType,
  ButtonPseudo,
  IconLoader,
  PermissionDenied,
  PermissionEnum,
} from '@ui/src';
import { useAppSelector } from '@store';
import { CofStatus } from '../../customers/types';
import CompanyItem from '../../../components/individual/overview/company-item';

import ROUTES from '../../../routes';

import cn from '../information.module.css';

const OverviewCompaniesPanel = () => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState<'current' | 'removed'>(
    'current',
  );

  const {
    individualCustomers: {
      info: {
        overview: { baseUserInformation },
      },
    },
    root: { activePermissions },
  } = useAppSelector((state) => state);

  const { customerId } = useParams();

  const transactionsMatch = useMatch(
    generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_COMPANIES, {
      customerId: customerId as string,
    }),
  );

  const navigate = useNavigate();

  const handleClose = () => {
    setPanelIsOpen(false);

    setTimeout(() => {
      navigate(
        transactionsMatch
          ? generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_TRANSACTIONS, {
              customerId: customerId as string,
            })
          : generatePath(ROUTES.CUSTOMERS_INDIVIDUAL_OVERVIEW_CARDS, {
              customerId: customerId as string,
            }),
      );
    }, 100);
  };

  useEffect(() => {
    setPanelIsOpen(true);
  }, []);

  let content;

  if (
    activePermissions?.includes(
      PermissionEnum.CORPORATE_CUSTOMERS_EDIT_OFFICIALS_ACTION,
    )
  ) {
    if (!baseUserInformation?.representativeOfOrganizations) {
      content = (
        <div className={cn.companyOfficialLoader}>
          <IconLoader />
        </div>
      );
    } else {
      content = (
        <>
          <div
            className={`${cn.companyOfficialTabs} ${cn.companyOfficialPanelTabs}`}
          >
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'current' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('current')}
            >
              Current
            </button>
            <button
              type="button"
              className={`${cn.companyOfficialTab} ${
                selectedTab === 'removed' ? cn.companyOfficialTabActive : ''
              }`}
              onClick={() => setSelectedTab('removed')}
            >
              Removed
            </button>
          </div>
          {selectedTab === 'current' &&
            baseUserInformation.representativeOfOrganizations &&
            baseUserInformation?.representativeOfOrganizations?.length > 0 &&
            baseUserInformation?.representativeOfOrganizations
              ?.filter(
                (item) =>
                  item.status !== CofStatus.ARCHIVED &&
                  item.status !== CofStatus.REJECTED,
              )

              .map((item) => (
                <CompanyItem
                  key={item.id}
                  value={item}
                  list={baseUserInformation?.representativeOfOrganizations}
                />
              ))}
          {selectedTab === 'removed' &&
            (baseUserInformation.representativeOfOrganizations &&
            baseUserInformation?.representativeOfOrganizations?.filter(
              (item) =>
                item.status === CofStatus.ARCHIVED ||
                item.status === CofStatus.REJECTED,
            )?.length > 0 ? (
              baseUserInformation?.representativeOfOrganizations
                ?.filter(
                  (item) =>
                    item.status === CofStatus.ARCHIVED ||
                    item.status === CofStatus.REJECTED,
                )
                .map((item) => (
                  <CompanyItem key={item.id} value={item} removed />
                ))
            ) : (
              <div className={cn.emptyRemoved}>No removed COF yet</div>
            ))}
        </>
      );
    }
  } else {
    content = <PermissionDenied />;
  }

  return (
    <>
      <div id="popup-modal" />
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={panelIsOpen}
        onClose={handleClose}
        title="Companies"
        sidepanelExpandedKey="customer-companies"
        footer={
          <div>
            <ButtonPseudo text="Close" onClick={handleClose} bold />
          </div>
        }
      >
        {content}
      </SidePanel>
    </>
  );
};

export default OverviewCompaniesPanel;
